// Copyright ©️ 2026 eVolve MEP, LLC

import './MobileDrawer.css';

import { Drawer, LoadingOverlay } from '@mantine/core';

import { focusAutoFocusElement } from 'components/Mantine/Modals/helpers';

import { PopoverConfirmation } from './PopoverConfirmation';
import type { PopoverContentProps } from './types';

/**
 * The mobile "dropdown" for a `WrappedPopover` - a bottom-anchored drawer.
 */
export const MobileDrawer = ({
  opened,
  onClose,
  onConfirm,
  withForm,
  disabled,
  loading,
  target,
  confirmationText,
  confirmationCount,
  withCloseButton,
  title,
  withinPortal,
  children,
}: PopoverContentProps) => (
  <>
    {target}
    <Drawer
      className="mobile-drawer"
      opened={opened}
      onClose={onClose}
      position="bottom"
      trapFocus
      withinPortal={withinPortal}
      offset={8}
      radius="md"
      title={title}
      withCloseButton={withCloseButton && !loading}
      closeOnClickOutside={!loading}
      transitionProps={{
        onEntered: () => focusAutoFocusElement('.mantine-Drawer-body'),
      }}
    >
      <PopoverConfirmation
        onConfirm={onConfirm}
        onClose={onClose}
        withForm={withForm}
        disabled={disabled}
        confirmationText={confirmationText}
        confirmationCount={confirmationCount}
      >
        {children}
      </PopoverConfirmation>

      <LoadingOverlay visible={loading} />
    </Drawer>
  </>
);
